import React, { useRef } from "react";
import GridCarousel from "./GridCarousel";
import dimensionCard from "../../../assets/img/dimensionCard.png";
import { Row } from "react-bootstrap";
import { Query } from "react-apollo";
import { addToDataLayerGTM } from "../../../utils/addToDataLayerGTM";
import { lms_client, GET_VIDEOS_TRENDING } from "../apollo";
import { SkeletonGrid } from "../../../components/Skeleton";
import ErrorModal from "../../../components/Modal/ErrorModal";

const MostWatched = () => {
  const imgref = useRef(null);

  return (
    <div className="content">
      <div className="container">
        <Row>
          <Query client={lms_client} query={GET_VIDEOS_TRENDING}>
            {({ loading, error, data }) => {
              if (loading)
                return (
                  <div>
                    <SkeletonGrid title="Mais assistidos">
                      <img ref={imgref} src={dimensionCard} />
                    </SkeletonGrid>
                  </div>
                );
              if (error) {
                // Google Tag Manager
                addToDataLayerGTM({
                  'event': 'erro',
                  'descricao': 'erro ao buscar GET_VIDEOS_TRENDING'
                });
                return <ErrorModal />;
              }
              if (!data.videos_trending.videos.length) {
                return <span />;
              }
              return (
                <div>
                  <GridCarousel
                    imgref={imgref}
                    title={"Mais assistidos"}
                    data={data.videos_trending.videos}
                    preRef={"/#/video/"}
                  />
                </div>
              );
            }}
          </Query>
        </Row>
      </div>
    </div>
  );
};
export default MostWatched;



// WEBPACK FOOTER //
// ./src/views/Home/components/MostWatched.jsx